export enum EAvailableContentType {
    DownloadableContent = 1,
    ELFWebsite = 2,
    VideoContent = 3,
    VendorTitle = 4
}

const AvailableContentTypeLabels = new Map<EAvailableContentType, string>();
AvailableContentTypeLabels.set(EAvailableContentType.DownloadableContent, 'Downloadable content');
AvailableContentTypeLabels.set(EAvailableContentType.ELFWebsite, 'Website');
AvailableContentTypeLabels.set(EAvailableContentType.VendorTitle, 'Vendor title');
AvailableContentTypeLabels.set(EAvailableContentType.VideoContent, 'Video content');

export { AvailableContentTypeLabels };
